export class CustomerProfileBorrowerDetailsController {

    static instance = {
        template: require('./borrower_details.html'),
        controller: [CustomerProfileBorrowerDetailsController],
        bindings: {
            "customer": "<"
        },
    };
}